import $http from '@Config/axios';

const prefix = 'indicame';

export const IndicamePresenter = {
	createCode: (campaing, farmembro) => $http.post(`${prefix}/${campaing}/gerarCodigo`, farmembro)
};
